<template>
    <div class="mdc-tab-bar faqs-slider" role="tablist">
        <div class="mdc-tab-scroller">
            <div class="mdc-tab-scroller__scroll-area">
                <div class="mdc-tab-scroller__scroll-content">
                    <button v-for="(category,index) in categories" :key="index"
                        class="mdc-tab"
                        :class="{ 'mdc-tab--active': isSelected(index) }"
                        role="tab"
                        aria-selected="true"
                        tabindex="0"
                        @click="itemselect(category,index)"
                    >
                        <span class="mdc-tab__content">
                            <span class="mdc-tab__text-label">
                                <p class="">{{ category.category[locale] }}</p>
                            </span>
                        </span>
                        <span class="mdc-tab-indicator" :class="{ 'mdc-tab-indicator--active': isSelected(index) }">
                            <span
                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                            ></span>
                        </span>
                        <span class="mdc-tab__ripple"></span>
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MDCTabBar } from "@material/tab-bar";
 import {MDCTabScroller} from '@material/tab-scroller';
export default {
    props: ["show"],
    data() {
        return {
            menuselect: 0,
            locale: window.appLocale
        };
    },props:{
        categories: Array
    },
    mounted() {
        const tabBar = new MDCTabBar(document.querySelector(".mdc-tab-bar"));


const tabScroller = new MDCTabScroller(document.querySelector('.mdc-tab-scroller'));
    },
    methods: {
        itemselect(categories,index){
            this.$emit('action',categories.id);
            this.menuselect = index;
        },
        isSelected(index){
            return this.menuselect === index;
        }
    }
};
</script>
<style lang="scss" scoped>
.faqs-slider {
    background-color: #00559a;
    overflow: auto;
    @media (min-width:1024px) {
        padding: 0 1rem;
        width: 100%;

    }
    .mdc-tab-scroller__scroll-content{
        @media (min-width:1024px) {
            max-width: 700px;
            margin: auto;
        }
    }
    p {
        color: #9a9c96;
    }
    .mdc-tab--active {
        p {
            color: white;
        }
    }
    button {

        margin: 0;
        &:hover {
            background-color: rgba($color: #000000, $alpha: 0.1);
        }
    }
    .mdc-tab-indicator .mdc-tab-indicator__content--underline {
        border-top-width: 2px;
        border-color: white!important;;
        color: white;
        @media (min-width: 1024px) {
            border-top-width: 3px;
        }
    }
    .mdc-tab {
        height: 80px;
        min-width: 150px;
    }
}

</style>
